import "./creditEarlyRepaymentChangeData.css";
import React from 'react';

const CreditEarlyRepaymentChangeData = (props) => {

    const earlyRepaymentChangeData = props.creditEarlyRepaymentChanges.map(creditEarlyRepaymentChange => (
        <>
            <tr key={creditEarlyRepaymentChange.key}>
                    <td>
                        {creditEarlyRepaymentChange.date}
                    </td>
                    <td>
                        {creditEarlyRepaymentChange.value}
                    </td>
                    <td>
                        {creditEarlyRepaymentChange.currency}
                    </td>
                    <td>
                        <button className="actionButtonTable" value={creditEarlyRepaymentChange.key} onClick={props.handleDeleteCreditEarlyRepaymentChange}>Usuń</button>
                    </td>
            </tr>
        </>
    ))

    const earlyRepaymentChangeDataStructure = (
        <table className="earlyRepaymentChangeTable">
                <tbody>
                    <tr>
                        <th>Data</th>
                        <th>Wartość</th>
                        <th>Waluta</th>
                        <th>Akcja</th>
                    </tr>
                    {earlyRepaymentChangeData}
                </tbody>
        </table> 
    )

    return ( 
        <>
            <div className="tableRow">
                {props.creditEarlyRepaymentChanges.length === 0 ? '' : earlyRepaymentChangeDataStructure}
            </div>  
        </>
    );
}
 
export default CreditEarlyRepaymentChangeData;
